import { formatDateISO } from "../../app-input/utils/dateUtils.js";

export const MONTH_NAMES_DE = ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'];

export function startOfWeek(date) {
    const d = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    const day = d.getDay();
    d.setDate(d.getDate() + (day === 0 ? -6 : 1 - day));
    return d;
}

function getISOWeekInfo(date) {
    const d = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
    const dayNum = (d.getUTCDay() + 6) % 7;
    d.setUTCDate(d.getUTCDate() - dayNum + 3);
    const firstThursday = new Date(Date.UTC(d.getUTCFullYear(), 0, 4));
    const firstDayNum = (firstThursday.getUTCDay() + 6) % 7;
    firstThursday.setUTCDate(firstThursday.getUTCDate() - firstDayNum + 3);
    const week = 1 + Math.round((d - firstThursday) / (7 * 24 * 60 * 60 * 1000));
    return { week, year: d.getUTCFullYear() };
}

export function computePeriodRange(mode, refDate) {
    if (mode === 'month') {
        const from = new Date(refDate.getFullYear(), refDate.getMonth(), 1);
        const to = new Date(refDate.getFullYear(), refDate.getMonth() + 1, 0);
        return { from: formatDateISO(from), to: formatDateISO(to), label: `${MONTH_NAMES_DE[refDate.getMonth()]} ${refDate.getFullYear()}` };
    }
    if (mode === 'year') {
        const from = new Date(refDate.getFullYear(), 0, 1);
        const to = new Date(refDate.getFullYear(), 11, 31);
        return { from: formatDateISO(from), to: formatDateISO(to), label: `${refDate.getFullYear()}` };
    }
    const monday = startOfWeek(refDate);
    const sunday = new Date(monday.getFullYear(), monday.getMonth(), monday.getDate() + 6);
    const { week, year } = getISOWeekInfo(monday);
    return { from: formatDateISO(monday), to: formatDateISO(sunday), label: `KW ${week} · ${year}` };
}

export function shiftRefDate(mode, refDate, direction) {
    if (mode === 'month') return new Date(refDate.getFullYear(), refDate.getMonth() + direction, 1);
    if (mode === 'year') return new Date(refDate.getFullYear() + direction, refDate.getMonth(), 1);
    const d = new Date(refDate);
    d.setDate(d.getDate() + 7 * direction);
    return d;
}